<template>
    <div class="modal-box"
         :class="{
            'modal-box--closed': !isOpen,
            'modal-box--default-width': !width,
            'modal-box--mobile-width':
              (($store.getters['getResolution'] < fullscreenMinWidth)
              && enableMobileFullscreen)
              ||
              enableAlwaysFullscreen
              ,
            'modal-box--pulsing': isPulsingInProgress,
          }"
    >
      <div class="overlay">

      </div>
      <div class="modal-container" @click="_processClickOnContainer">
        <div class="modal"
             :style="[styleModalObject]"
             @click.stop
        >
          <!--<div class="border-top"></div>-->
          <!--<div class="border-bottom"></div>-->
          <!--<div class="border-left"></div>-->
          <!--<div class="border-right"></div>-->
          <div class="cross"
               v-if="!hideCloseButton"
               @click="close()"
          ></div>
          <slot></slot>
        </div>

      </div>
    </div>
</template>

<script>
    //import comp from '@/path/to/comp.vue';    //от папки src указанной в webpack
    import bodyLocker from '../JE/bodyLocker';
    /**
     * @Зависимости:
     * * Ширина окна в vuex ($store.getters['getResolution'])
     * * bodyLocker (из JE)
     * @publicMethods: open(), close()
     * @CSSModifiers: меняются от проекта к проекту. Дописываются внизу стилей
     * @emits: open, close
     * @ЧегоИПочемуНет:
     *    slot для cross: по нормальному - один стиль на весь проект
     *    overlay-theme property: по нормальному - один стиль оверлея на весь проект
     *
     * @caveats
     * Во всех модальных окнах есть такая проблема:
     * * Крест внутри модального. Внутри потому что на мобиле модалка раскрывается на весь экран.
     * * Контента много, и он скроллится внутри модалки.
     * * Крест скроллится вместе с контентом, пушо иначе он залезет на контент.
     * Проблема вроде решаемая а вроде нет.
     * Потом можно будет, конечно, попробовать переделать.
     * А вообще контента в модалке должно быть немного,
     * и нехер в него пихать столько контента, чтоб аж скроллить приходилось.
     */
    export default {
//        name: 'modal-box',
      components: {
      },
      props: {
        //при true, нельзя закрыть окно, кликая по оверлею
        blocking: {
          type: Boolean,
          default: false
        },
        //при true при попытке закрыть блокирующее окно по оверлею происходит эффект
        pulseOnBlock: {
          type: Boolean,
          default: true,
        },
        //If true, close button is hidden.
        hideCloseButton: {
          type: Boolean,
          default: false
        },
        //если не указана - ставит ширину по умолчанию, см соответственный css-модификатор
        //Добавить в перспективе тип Number, и если передался number - автоматически добавлять px
        //Сейчас строка должна передаваться с единицей измерения.
        //Но может проще прямо внутри этого файла писать модивикатор?
        width: {
          type: [String],
          default: null
        },
        //если true, то модалка тянется на весь экран на мобилах
        enableMobileFullscreen: {
          type: Boolean,
          default: true
        },
        //если true, то модалка тянется на весь экран на любом экране
        enableAlwaysFullscreen: {
          type: Boolean,
          default: false,
        },
        //ширина, ниже или равно которой модалка тянется на весь экран при enableMobileFullscreen == true
        fullscreenMinWidth: {
          type: Number,
          default: 640
        }
      },
      data(){
        return {
          isPulsingInProgress: false,
          isOpen: false,
        }
      },
      computed: {
        styleModalObject() {
          let result = {}
          if (this.width) {
            result.width = this.width;
          }
          return result;
        }
      },
      methods: {
        //public
        open(){
          this.isOpen = true;
          bodyLocker.lock();
          this.$emit('open');

        },
        //public
        close(){
          this.isOpen = false;
          bodyLocker.unlock();
          this.$emit('close');
        },
        _processClickOnContainer(){
          if (this.blocking){
            if (this.pulseOnBlock){
              this._pulse();
            }
          } else {
            console.log('close')
          }

        },
        _pulse(){
          console.log('_pulse')
          this.isPulsingInProgress = true;
          setTimeout(()=>{
            this.isPulsingInProgress = false;
          },300)
        }
      },

    }
</script>
<style scoped lang="scss">
  @import 'src/scss/vars';    //от папки со сборкой

  .modal-box {
    z-index: 23;
    transition: opacity $timeShort;
    .overlay {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: $clrBlack;
      opacity: 0.9;
      z-index: 23;
      transition: opacity $timeShort; //edge fix
    }
    .modal-container {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 24;
      display: flex;
      justify-content: center;
      align-items:center;
      transition: opacity $timeShort; //edge fix

      .modal {
        min-height:50px;
        width:50%;
        background-color: #fff;
        position: relative;

        /*max-height: 80vh;*/
        max-height: calc(var(--vh) * 0.8);
        overflow-y: auto;
        overflow-x: hidden;
        border: 1px dotted $clrAcc;
        background-color: $clrBgDarkLess;

        .cross {
          z-index: 1;
          cursor: pointer;
          outline: 1px solid darkred;
          position: absolute;
          width: 20px;
          height: 20px;
          right: 0;
          top: 0;
        }
      }
    }
  }

  .modal-box.modal-box--closed {
    opacity: 0;
    pointer-events: none;
    .overlay {
      opacity: 0; //edge fix
    }
    .modal-container {
      opacity: 0; //edge fix
    }
  }
  .modal-box.modal-box--default-width {
    .modal-container {
      .modal {
        //взял размеры из sweet-modal-vue
        width: 80%;
        /*max-width: 640px;*/
        max-width: calc( 640 * var(--px));
      }
    }
  }
  .modal-box.modal-box--mobile-width {
    .modal-container {
      .modal {
        outline: 1px solid darkred;
        width: 100vw; // здесь, ВРОДЕ БЫ, не может быть скроллбара, поэтому как-то работает без переменных
        //чтобы переопределить стандартные
        max-width: 100vw; // здесь, ВРОДЕ БЫ, не может быть скроллбара, поэтому как-то работает без переменных
        
        
        /*height: 100vh;*/
        height: var(--vh);
        /*max-height: 100vh;*/
        max-height: var(--vh);
      }
    }
  }
  .modal-box.modal-box--pulsing {
    .modal-container {
      .modal {
        @keyframes myAnimation {
          from {transform: scale(1);}
          50% {transform: scale(1.03);}
          to {transform: scale(1);}
        }
        animation: myAnimation 0.3s;
      }
    }
  }

  //далее - переопределяющие стили для проекта

  //здесь описывается крест
  .modal-box {
    .modal-container {
      .modal {
        .cross {
          background-image: url('../img/details/Cross.svg');
          height: calc( 33 * var(--px));
          width:calc( 33 * var(--px));
          outline: none;
          right:calc( 16 * var(--px));
          top:calc( 16 * var(--px));
        }
      }
    }
  }

  .modal-box.modal-box--contact-form {
    .modal-container {
      .modal {
        @media (min-width: $bp0704) {
          width:calc( var(--vw) - (var(--sizeCell) * 2));
          max-width:calc( var(--vw) - (var(--sizeCell) * 2));
        }
        @media (min-width: $bp1152) {
          width:calc((var(--sizeMegaCell) * 3));
          max-width:calc((var(--sizeMegaCell) * 3));
        }
        @media (min-width: $bp1376) {
          width:calc((var(--sizeMegaCell) * 4));
          max-width:calc((var(--sizeMegaCell) * 4));
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/modal-box.vue